import React, { memo, useState } from 'react';
import {
  WebScrollView,
  LoadingContainer,
  Space,
  PanelCompatibleContainer,
} from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import {
  SetupPageTitle,
  Button,
  TextInput,
} from '@redlink/components/molecules';
import { useMutation, editPageNameQuery } from '@redlink/services';
import { useNavigation, StackActions } from '@react-navigation/native';

export const PageNameSetupPage = memo(({ navigation }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  const { routes, constants } = useValues();
  const [pageName, setPageName] = useState('');
  const { dispatch: navigationDispatch } = useNavigation();

  const [edit, { loading }] = useMutation(editPageNameQuery, {
    done: () =>
      navigationDispatch(StackActions.replace(routes.pageFullnameSetup.key)),
  });

  return (
    <LoadingContainer isBusy={loading} style={styles.container}>
      <WebScrollView>
        <PanelCompatibleContainer>
          <SetupPageTitle
            title={dictionary.setupPageTitle}
            subtitle={dictionary.setupPageNameTitle}
            description={dictionary.setupPageNameDescription}
            hints={dictionary.setupPageNameHints}
            step={1}
          />
          <Space size={32} />
          <TextInput
            title={dictionary.yourLink}
            require
            en
            prefix={constants.pageLinkPrefix}
            value={pageName}
            onChangeText={(value) => setPageName(value)}
          />
          <Space size={32} />
          <Button
            style={styles.formActionContainer}
            title={dictionary.continue}
            variant="primary"
            onPress={() => {
              edit({
                name: pageName,
              });
            }}
          />
        </PanelCompatibleContainer>
      </WebScrollView>
    </LoadingContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  formActionContainer: {
    minHeight: 50,
  },
}));
